var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBlock24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48455",
    "data-name": "Path 48455",
    d: "M312.34,389.66A8.966,8.966,0,1,0,315,396,8.988,8.988,0,0,0,312.34,389.66Zm-3.254,11.5a5.941,5.941,0,0,1-3.061.855H306a6.02,6.02,0,0,1-5.171-9.1Zm-6.167-10.336a6.019,6.019,0,0,1,9.1,5.173,5.935,5.935,0,0,1-.855,3.083Z",
    transform: "translate(-297 -387)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBlock24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_block24x24.2ae0c49dcddb0b5d3b1a832c69b16918.svg";